<script setup lang="ts">
  import InfoIcon from '@/shared/assets/icons/InfoIcon.svg';
  import { IconImage } from '@/shared/ui';
</script>

<template>
  <div class="flex flex-col gap-3 w-full">
    <div class="flex gap-2">
      <IconImage
        :src="InfoIcon"
        alt="Info"
        class="text-gray-03"
      />
      <h2 class="text-gray-03 text-sm font-semibold">
        Requisitos para adicionar documentos
      </h2>
    </div>
    <p>
      Você pode enviar arquivos através de <span class="font-semibold">Upload</span> ou de
      <span class="font-semibold">URL</span>, para isso, deve selecionar previamente o formato que
      deseja utilizar.
    </p>
    <div class="flex flex-col gap-1">
      <span>Arquivos podem ter as extensões:</span>
      <span>
        <span class="font-semibold">.pdf | .docx | .txt | .pptx | .xlsx | .xlsm</span>
      </span>
    </div>
  </div>
</template>
